/*
 * Copyright (c) 2023 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

import { Label } from "reactstrap";

const LoginMetrics = ({data}) => {
  const metrics = data?.data;
  return metrics ? (
    <div className="px-3 fill-container d-flex justify-content-between flex-column">
      <Label className="flex-dynamic w-100 text-center" style={{ fontSize: "22px" }}>Login Metrics</Label>
      <div className="flex-dynamic d-flex justify-content-between">
        <div className="flex-40">
          <Label className="text-muted no-spacing" tag="h5">Weekly Logins</Label>
          <Label className="no-spacing" tag="h4">{metrics.weeklyLogins.toLocaleString()}</Label>
        </div>
        <div className="flex-20" />
        <div className="flex-40">
          <Label className="text-muted no-spacing" tag="h5">Monthly Logins</Label>
          <Label className="no-spacing" tag="h4">{metrics.monthlyLogins.toLocaleString()}</Label>
        </div>
      </div>
      <div className="flex-dynamic d-flex justify-content-between">
        <div className="flex-40">
          <Label className="text-muted no-spacing" tag="h5">Yearly Logins</Label>
          <Label className="no-spacing" tag="h4">{metrics.yearlyLogins.toLocaleString()}</Label>
        </div>
        <div className="flex-20" />
        <div className="flex-40">
          <Label className="text-muted no-spacing" tag="h5">All Time Logins</Label>
          <Label className="no-spacing" tag="h4">{metrics.allLogins.toLocaleString()}</Label>
        </div>
      </div>
    </div>
  ) : null;
};

export default LoginMetrics;
